@let p = post();
@if (p) {
  <article
    class="blog-post"
    [class.blog-post--front-door]="p.type === 'front-door'"
  >
    <header class="blog-post-header">
      <p class="blog-post-meta">
        <time [attr.datetime]="p.datePublished">
          {{ p.datePublished | date: "longDate" }}
        </time>
        <span aria-hidden="true">·</span>
        <a [routerLink]="['/blog/topic', p.category]">{{ categoryLabel() }}</a>
        <span aria-hidden="true">·</span>
        <a class="blog-post-level" [routerLink]="['/blog/difficulty', p.level]">
          {{ levelLabel() }}
        </a>
        <span aria-hidden="true">·</span>
        <span>{{ p.readingTimeMinutes }} min read</span>
      </p>
      @if (p.dateModified && p.dateModified !== p.datePublished) {
        <p class="blog-post-updated">
          Updated
          <time [attr.datetime]="p.dateModified">
            {{ p.dateModified | date: "longDate" }}
          </time>
        </p>
      }
      <p class="blog-post-byline">
        <img
          class="blog-post-byline-avatar"
          ngSrc="/images/russ-bio-image.webp"
          width="32"
          height="32"
          alt=""
        />
        <span>By Russ Rodgers</span>
      </p>
    </header>

    @let yt = youtubeResource();
    @if (yt) {
      <div class="blog-post-hero">
        <app-youtube-section
          [resource]="yt"
          [placeholderImageQuality]="thumbQuality()"
          [placeholderWebpImage]="thumbWebp()"
          placeholderPriority
        />
      </div>
    } @else {
      <div class="blog-post-no-yt-hero" aria-hidden="true">
        <img
          class="blog-post-no-yt-hero-logo"
          src="/images/russlogo-200x200-black-bg.webp"
          alt=""
          width="120"
          height="120"
        />
      </div>
    }

    <div class="blog-post-body" [innerHTML]="bodyHtml()"></div>

    @if (p.transcript) {
      <details class="blog-post-transcript">
        <summary>Read the transcript</summary>
        <div class="blog-post-transcript-body">{{ p.transcript }}</div>
      </details>
    }

    @if (p.type === "front-door") {
      <!-- Pricing teaser with the real numbers; the link always targets the
           hub's pricing section, regardless of the post's `hubAnchor`. -->
      <section
        class="front-door-price-teaser"
        aria-labelledby="front-door-price-heading"
      >
        <div
          class="front-door-price-teaser-card"
          grooveSurface
          variant="bordered"
          tone="raised"
          size="lg"
        >
          <h2 id="front-door-price-heading">What it costs</h2>
          <p class="front-door-price-teaser-amount">
            <span class="groove-type-display">$55</span>
            <span class="front-door-price-teaser-unit">/ hour</span>
          </p>
          <p>$50 an hour when you buy 4 or more hours in advance.</p>
          <p>
            <a routerLink="/" fragment="price-and-scheduling">
              See full pricing &amp; scheduling&nbsp;&rarr;
            </a>
          </p>
        </div>
      </section>

      @if (p.faq && p.faq.length > 0) {
        <!-- The post's own front-matter FAQ as native disclosures, always
             open, same as the hub body's FAQ. -->
        <section class="blog-post-faq" aria-labelledby="faq-heading">
          <h2 id="faq-heading">Frequently asked questions</h2>
          <app-disclosure-group>
            @for (item of p.faq; track item.q) {
              <app-disclosure [summary]="item.q" [open]="true">
                <p>{{ item.a }}</p>
              </app-disclosure>
            }
          </app-disclosure-group>
        </section>
      }

      @if (siblingFrontDoorPosts().length > 0) {
        <section class="blog-post-related" aria-labelledby="related-heading">
          <h2 id="related-heading">Other questions people ask</h2>
          <ul class="blog-post-related-list" role="list">
            @for (related of siblingFrontDoorPosts(); track related.slug) {
              <li>
                <a [routerLink]="['/blog', related.slug]">{{
                  related.title
                }}</a>
              </li>
            }
          </ul>
        </section>
      }

      <p class="front-door-hub-link">
        Thinking about lessons?
        <a routerLink="/" [fragment]="p.hubAnchor">
          See how online lessons work&nbsp;&rarr;
        </a>
      </p>
    } @else {
      <!-- A quiet push toward the funnel: one sentence and one link, no CTA
           buttons, no price (that is the front-door tier's job). -->
      <aside
        class="library-further"
        aria-labelledby="library-further-heading"
        grooveSurface
        variant="bordered"
        size="md"
      >
        <h2 id="library-further-heading" class="library-further-heading">
          Taking this further
        </h2>
        <p class="library-further-body">
          If you would rather work on this with me than read about it, I teach
          live one-on-one lessons over Zoom, and this is exactly the kind of
          thing we would dig into together.
        </p>
        <a
          class="library-further-link groove-text-link groove-ring"
          data-tone="accent"
          routerLink="/"
        >
          See how online lessons work&nbsp;&rarr;
        </a>
      </aside>

      @if (moreInCategory().length > 0) {
        <section class="blog-post-related" aria-labelledby="related-heading">
          <h2 id="related-heading">More in this category</h2>
          <ul class="blog-post-related-list" role="list">
            @for (related of moreInCategory(); track related.slug) {
              <li>
                <a [routerLink]="['/blog', related.slug]">{{
                  related.title
                }}</a>
              </li>
            }
          </ul>
        </section>
      }
    }
  </article>

  <app-page-cta location="bottom" />
} @else {
  <section class="blog-post-missing">
    <p>
      That post doesn't exist —
      <a routerLink="/blog">browse all posts</a>
      instead.
    </p>
  </section>

  <app-page-cta location="bottom" heading="Want bass lessons with Russ?" />
}
